import { WebUrlType } from '@api/v3';

import {
  BookerSearchViewModel,
  BookerWebUrlType,
} from './BookerSearchViewModel';

const groupItemsByTypes = (
  items: BookerSearchViewModel[],
  types: (WebUrlType | BookerWebUrlType)[]
) => {
  if (!Array.isArray(items)) {
    return [];
  }
  const groupedItems: BookerSearchViewModel[] = [];

  items?.forEach((item) => {
    if (item?.type && types.includes(item.type)) {
      groupedItems.push(item);
    }
  });

  return groupedItems;
};

const generateCategoriesItems = (locations: BookerSearchViewModel[]) => {
  const hotelTypeItems = groupItemsByTypes(locations, [
    WebUrlType.HOTEL,
    WebUrlType.HOTEL_CHAIN,
  ]);

  const themeTypeItems = groupItemsByTypes(locations, [WebUrlType.HOTEL_THEME]);

  const regionTypeItems = groupItemsByTypes(locations, [
    WebUrlType.HOTEL_REGION,
  ]);

  const cityTypeItems = groupItemsByTypes(locations, [WebUrlType.HOTEL_CITY]);

  return { hotelTypeItems, regionTypeItems, themeTypeItems, cityTypeItems };
};

export const generateLocalLocationsCategories = ({
  locations,
  label,
}: {
  label: string;
  locations: BookerSearchViewModel[];
}) => {
  const localLocations = Array.isArray(locations)
    ? locations.filter((item) => Boolean(item?.domestic))
    : [];
  const { cityTypeItems, regionTypeItems, themeTypeItems, hotelTypeItems } =
    generateCategoriesItems(localLocations);

  return {
    label: label,
    items: [
      { label: 'ŞEHİR', items: cityTypeItems },
      { label: 'BÖLGELER', items: regionTypeItems },
      { label: 'TEMALAR', items: themeTypeItems },
      { label: 'OTELLER', items: hotelTypeItems },
    ],
    totalCount: localLocations?.length ?? 0,
  };
};

export const generateAbroadLocationsCategories = ({
  locations,
  label,
}: {
  label: string;
  locations: BookerSearchViewModel[];
}) => {
  const abroadLocations = Array.isArray(locations)
    ? locations.filter((item) => Boolean(!item?.domestic))
    : [];

  const { cityTypeItems, regionTypeItems, themeTypeItems, hotelTypeItems } =
    generateCategoriesItems(abroadLocations);

  return {
    label: label,
    items: [
      { label: 'ŞEHİR', items: cityTypeItems },
      { label: 'BÖLGELER', items: regionTypeItems },
      { label: 'TEMALAR', items: themeTypeItems },
      { label: 'OTELLER', items: hotelTypeItems },
    ],
    totalCount: abroadLocations?.length ?? 0,
  };
};
